import React, { createContext, useContext, useState } from 'react';
import { loginUser, registerUser, verifyLoginOtp } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // Lazy initializer — reads localStorage synchronously so first render has correct user
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem('vc_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false); // always false — no async init needed

  const login = async (email, password) => {
    const { data } = await loginUser(email, password);
    const { user: userData, accessToken, refreshToken } = data.data;
    localStorage.setItem('vc_access_token', accessToken);
    localStorage.setItem('vc_refresh_token', refreshToken);
    localStorage.setItem('vc_user', JSON.stringify(userData));
    // Keep backward-compatible key for Header.jsx legacy check
    localStorage.setItem('vietclinics_user', JSON.stringify({ ...userData, isLoggedIn: true }));
    setUser(userData);
    return userData;
  };

  const loginWithOtp = async (email, code) => {
    const { data } = await verifyLoginOtp(email, code);
    const { user: userData, accessToken, refreshToken } = data.data;
    localStorage.setItem('vc_access_token', accessToken);
    localStorage.setItem('vc_refresh_token', refreshToken);
    localStorage.setItem('vc_user', JSON.stringify(userData));
    localStorage.setItem('vietclinics_user', JSON.stringify({ ...userData, isLoggedIn: true }));
    setUser(userData);
    return userData;
  };

  const register = async (name, email, phone, password) => {
    const { data } = await registerUser(name, email, phone, password);
    const { user: userData, accessToken, refreshToken } = data.data;
    localStorage.setItem('vc_access_token', accessToken);
    localStorage.setItem('vc_refresh_token', refreshToken);
    localStorage.setItem('vc_user', JSON.stringify(userData));
    localStorage.setItem('vietclinics_user', JSON.stringify({ ...userData, isLoggedIn: true }));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('vc_access_token');
    localStorage.removeItem('vc_refresh_token');
    localStorage.removeItem('vc_user');
    localStorage.removeItem('vietclinics_user');
    setUser(null);
  };

  // Sync user state + localStorage after profile/avatar updates
  const updateUser = (updatedData) => {
    const updated = { ...user, ...updatedData };
    localStorage.setItem('vc_user', JSON.stringify(updated));
    localStorage.setItem('vietclinics_user', JSON.stringify({ ...updated, isLoggedIn: true }));
    setUser(updated);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithOtp, logout, register, updateUser, isLoggedIn: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
  return ctx;
};

export default AuthContext;
